import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import Template from 'behaviors/properties/main/confirmation.ejs';
//=====================================================================
//
// An instance of this view represents an auto-summary.
//
// Casey Justus, April 14, 2016
//
//=====================================================================

class MainConfirmationView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox], input[name="submitAsChildIfNoParent"]'    : 'updateCheckAttributes',
            'change input[type=text]'    : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        if(!this.model.get('showConfirmation')){
            this.model.set('showConfirmation','', {silent: true});
        }
        if (!this.model.get('confirmationMessage')){
            this.model.set('confirmationMessage','', {silent: true});
        }
        if (this.model.get('submitAsChildIfNoParent') === undefined) {
            this.model.set('submitAsChildIfNoParent',false, {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set( propName, propVal );
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let bShowConfirmation = util.isTrue(this.model.get('showConfirmation'));
        let bSubmitAsChildIfNoParent = util.isTrue(this.model.get('submitAsChildIfNoParent'));
        $(`input[name='showConfirmation']`).prop('checked', bShowConfirmation );
        $(`input[name='submitAsChildIfNoParent']`).prop('checked',bSubmitAsChildIfNoParent );

        this.delegateEvents();
        return this;
    }

}

export default MainConfirmationView;
